// Backend limits for the profile name and surname. Each settings form keeps its own messages.
export const PROFILE_NAME_MAX_LENGTH = 200
export const PROFILE_NAME_MIN_LENGTH = 2
export const PROFILE_NAME_PATTERN = /^[^{}[\]?\\=:!#$^&%*;()|~<>]+$/
// The pattern also blocks a backslash, so the message lists it too.
export const PROFILE_NAME_BLOCKED_CHARACTERS = '^{}[]?=:!#$&%*;()|~<>\\'
